import { Button } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { deepmerge } from '@mui/utils';

const ButtonNegative = (props) => {
    const { sx: userSx, ...otherProps } = props;

    const defaultSx = {
        color: 'white',
        backgroundColor: 'primary.main',
        border: '1px solid white',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: 'primary.main',
            boxShadow: 'none',
        },
    };

    const combinedSx = deepmerge(defaultSx, userSx);

    return (
        <Button
            sx={combinedSx}
            {...otherProps}
        />
    );
};

ButtonNegative.propTypes = {
    sx: PropTypes.object,
};

export default ButtonNegative;
